import {
  DailyStatisticsType,
  MonthlySalesStatisticsType,
} from 'types/report';
import { ginzaxiaomaApiRequest } from '.';

export const getDailyStatistics = (dto: {
  date: string;
  createdFrom?: number;
  stockPlace?: string;
}) => {
  return ginzaxiaomaApiRequest.get<DailyStatisticsType>(
    '/admin/order/daily-statistics',
    {
      params: dto,
    }
  );
};

export const getMonthlySalesStatistics = (params: {
  date?: string;
  excludeB2B?: boolean;
}) => {
  return ginzaxiaomaApiRequest.get<MonthlySalesStatisticsType[]>(
    '/admin/order/monthly-sales-statistics',
    { params }
  );
};
